import {AddProjectTimeEvent, CombinedTimelineDayComponentConfig, ProjectTimeTimelineDayContent} from "../timelineTypes";
import {EVENT_PROJECT_TIME_ADD} from "../timelineConstants";
import {getDialogPresetDateTime} from "../timelineHelper";
import {isProjectTimeDateTimeChangeAllowed} from "@/shared/securityHelper";
import {
	formatDate,
	formatDateDay,
	formatDateWithoutYear,
	formatDuration,
	parseISODate
} from "@/shared/utils/datefunctions";
import {TimelineMode} from "@/shared/timrTypes";

/**
 * Component to draw the title section of a project time timeline day including date and statistics.
 * This component is used inside <code>ProjectTimeTimelineDay</code> to render the title for a specific day. If available this component is appended to the day container.
 * For an overview of the timeline architecture, have a look into the UML diagram "timeline_web_components.png"
 */
export class ProjectTimeTimelineDayTitle extends HTMLElement {
	private _timelineDay: ProjectTimeTimelineDayContent;
	private _config: CombinedTimelineDayComponentConfig;

	set timelineDay(value: ProjectTimeTimelineDayContent) {
		this._timelineDay = value;
	}

	set config(value: CombinedTimelineDayComponentConfig) {
		this._config = value;
	}

	/**
	 * Main entry point to render the title section.
	 */
	public connectedCallback(): void {
		// the content (timelineDay), config and contextMenu are required to render this component
		if (!this._timelineDay || !this._config) {
			return;
		}

		const {statistics, date} = this._timelineDay;
		const parsedDate = parseISODate(date);
		const dateSpan = this._config.mode === TimelineMode.Daily ?
			`<span>${formatDateDay(parsedDate)}, ${formatDate(parsedDate)}</span>` :
			`<span>${formatDateDay(parsedDate)}<br/> ${formatDateWithoutYear(parsedDate)}</span>`;

		this.innerHTML = `
				${dateSpan}
				<div style="display: flex; align-items: start;">
					<div class="title-statistics">
						<span><i class="fal fa-business-time position-left"></i>${formatDuration(statistics.projectTimesDurationInMilliseconds)}</span>
					</div>
					<button class="btn btn-link btn-link-primary btn-xs pt-0" ${!isProjectTimeDateTimeChangeAllowed(this._config.reportingOtherUsers) ? `disabled="disabled"` : ""}>
						<i class="fal fa-plus" title="${messages["timeline.workingTime.addProjectTime"]}"></i> 
					</button>
				</div>`;

		if (isProjectTimeDateTimeChangeAllowed(this._config.reportingOtherUsers)) {
			this.querySelector(".btn-link").addEventListener("click", () => {
				const defaultDateTime = getDialogPresetDateTime(parsedDate);
				const event = new CustomEvent<AddProjectTimeEvent>(EVENT_PROJECT_TIME_ADD, {
					detail: {
						start: defaultDateTime.start,
						end: defaultDateTime.end
					},
					bubbles: true
				});
				this.dispatchEvent(event);
			});
		}
	}
}
